export const setLoggingIn = (): void => sessionStorage.setItem('hpl', 'true');
export const isLoggingIn = (): string | null => sessionStorage.getItem('hpl');
export const finishLoggingIn = (): void => sessionStorage.removeItem('hpl');
